<dx-tabs
  width="100%"
  [selectedIndex]="selectedTabIndex"
  [dataSource]="top10RecordsData"
  displayExpr="title"
  (onItemClick)="onTabChange($event)"
></dx-tabs>

<div
  class="table-wrapper"
  *ngFor="let tab of top10RecordsData; let i = index"
>
  <ng-container *ngIf="i === selectedTabIndex">
    <app-table
      [data]="tab.data"
      [columns]="tab.columns"
      [pageSize]="10"
      [showPagination]="false"
      [showExport]="false"
      [allowDataEditing]="false"
      [showPageSizeSelector]="false"
      [showGrouping]="false"
      (onRowClick)="onTopRecordClick($event)"
    ></app-table>
  </ng-container>
</div>
